module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/CalculatorCellulose-a5b27284a210e064e577dd28b6ae0eab.png";